var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[(_vm.display)?_c('div',{class:( _obj = {}, _obj[_vm.$style.isWhite] = _vm.isWhite, _obj[_vm.$style.ring] = true, _obj )},[_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }